<template>
    <div>
        <b-container>
        <h2>Hashtag Generator for Instagram</h2>
        <p>
            We are introducing our new standalone Hashtag Generator app for Instagram!
        </p>
            <p>
                <a class="btn btn-primary" href="https://play.google.com/store/apps/details?id=com.ritekit.hashtag_generator_io" target="_blank"> <font-awesome-icon :icon="['fab', 'android']"/> Get from Google Play</a>
                &nbsp;
                <a class="btn btn-primary" href="https://apps.apple.com/us/app/hashtag-generator-by-ritetag/id1497153067" target="_blank"> <font-awesome-icon :icon="['fab', 'apple']"/> Get from App Store</a>
            </p>
            <br>
            <br>
            <b-row>
                <b-col sm="3">
                    <p>
                        <img src="https://cdn.ritekit.com/assets/img/ritetag/hashtag-generator/00.png" class="img-fluid"/>
                    </p>
                    <!-- TODO: validate email -->
                    <p class="text-center">Enter your RiteTag account email <mark v-if="getEmail"><strong>{{getEmail}}</strong></mark> and re-type a code that you get in your inbox. This has to be done only once.</p>
                </b-col>
                <b-col sm="3">
                    <p>
                        <img src="https://cdn.ritekit.com/assets/img/ritetag/hashtag-generator/01.png" class="img-fluid"/>
                    </p>
                    <p class="text-center">Enter any Instagram @username and tap <strong>Load</strong>. No auth required, recent photos load instantly.</p>
                </b-col>
                <b-col sm="3">
                    <p>
                        <img src="https://cdn.ritekit.com/assets/img/ritetag/hashtag-generator/02.png" class="img-fluid"/>
                    </p>
                    <p class="text-center">Tap to deselect any hashtags you don't want, tap <strong>Copy</strong> and then tap <strong>Open photo in Instagram</strong>.</p>
                </b-col>
                <b-col sm="3">
                    <p>
                        <img src="https://cdn.ritekit.com/assets/img/ritetag/hashtag-generator/03.png" class="img-fluid"/>
                    </p>
                    <p class="text-center">Paste your hashtags as a comment and tap <strong>Post</strong>. Repeat the process for each photo. </p>
                </b-col>
            </b-row>
            <br>

        </b-container>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'

    export default {
        name: 'InstaGeneratorTeaser',
        props: ['currentRoute'],
         methods: {
            changeCurrentRoute () {
                if (this.currentRoute !== this.$route.path) {
                    this.$emit('changeRoute')
                }
            }
        },
        computed: {
            ...mapGetters('account', [
                'getEmail'
            ])
        }
    }
</script>

<style scoped>
.img-fluid {
    border: 1px solid #e2e2e2;
    border-radius: .5rem;
    box-shadow: 0 10px 15px -3px rgba(0,0,0,.1), 0 4px 6px -2px rgba(0,0,0,.05);
    margin-bottom: 20px;
}
</style>
